import { Injectable, OnInit } from '@angular/core';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { ModalStatusService } from './modal-status.service';

@Injectable({
  providedIn: 'root'
})
export class CustomModalService {

  private modalRefs: { [id: string]: BsModalRef } = {};

  constructor(private _modalService: BsModalService,
    private _modalStatusService: ModalStatusService) {}

  show<T>(content: any, config?: ModalOptions<T>, modalId: string = undefined): BsModalRef<T> {
    this.forceShowModalBackdrop();

    if(modalId != undefined) {
      let status = this._modalStatusService.getMinimizedStatus(modalId);
      status = status == null || status == undefined ? false : status;
      this._modalStatusService.setMinimizedStatus(modalId, status);
      if(status) {
        return null;
      }
    }

    const modalRef = this._modalService.show(content, config);
    if (modalId && modalRef) {
      this.modalRefs[modalId] = modalRef;
    }

    return modalRef;
  }

  close(modalId: string): void {
    const modalRef = this.modalRefs[modalId];
    if (modalRef) {
      modalRef.hide();
      delete this.modalRefs[modalId];
      this._modalStatusService.setMinimizedStatus(modalId, false);
    }
  }

  forceShowModalBackdrop() {
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.classList.remove('d-none');
      backdrop.classList.add('show');
    }
  }
}

